import { render } from "./OrgStructure.vue?vue&type=template&id=1cc4d566&scoped=true"
import script from "./OrgStructure.vue?vue&type=script&lang=js"
export * from "./OrgStructure.vue?vue&type=script&lang=js"

import "./org-structure.scss?vue&type=style&index=0&id=1cc4d566&lang=scss&scoped=true"
import "./OrgStructure.vue?vue&type=style&index=1&id=1cc4d566&lang=scss"

import exportComponent from "/Users/soil2sons/Projects/Work/Ensibuuko/hrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc4d566"]])

export default __exports__